<div class="title_nav" id="logoContainer">
    <div class="brand">
       <a class="navbar-brand" href="/"><img src="/assets/img/Logo resized.svg"></a>
    </div>
</div>
<div class="row bgSection" id="main">
    <div class="col-12 positionAbsolute" *ngIf="erroralert">
      <div class="alert-box grid-100" *ngIf="errorMessage">
        <div class="alert alert-danger mt-3 text-center">
          <a class="close link" data-dismiss="alert" (click)="erroralert=false">×</a>
          {{errorMessage}}
        </div>
      </div>
    </div>
    <div class="col-12" *ngIf="successalert">
      <div class="alert-box grid-100" *ngIf="successMessage">
        <div class="alert alert-success mt-3 text-center">
          <a class="close link" data-dismiss="alert"  (click)="successalert=false">×</a>
          {{successMessage}}
        </div>
      </div>
    </div>
    <div class="col-sm-12 mt-4">
      <div class="form_div">
        <!-- <form [formGroup]="loginForm" (ngSubmit)="submit(loginForm.value)">
          <div class="loginFormContainer">
            <div class="text-center" data-background-color="orange">
              <h2 class="mb-5 formHeading">Log In</h2>
              <app-error-label [control]="loginForm" [submitted]="submitted"></app-error-label>
            </div>
            <div class="">
              <app-input-field [attribute]="'email'"
                               [type]="'email'"
                               [placeholder]="'Email Address'"
                               [icon]="'email'"
                               [control]="loginForm.controls['email']"
                               [submitted]="submitted" id="email">
              </app-input-field>
              <small class="text-danger ml-3" *ngIf="showvalidEmailMsg">Please enter email.</small>
              <app-input-field [attribute]="'password'"
                               [type]="'password'"
                               [placeholder]="'Password'"
                               [icon]="'lock_outline'"
                               [control]="loginForm.controls['password']"
                               [submitted]="submitted" id="password">
              </app-input-field>
              <small class="text-danger ml-3" *ngIf="showvalidPasswordMsg">Please enter password.</small>
            </div>
            <button type="submit" class="button button_emi">LOG IN</button>
          </div>
          <a data-toggle="modal" data-target="#forgotpasswordModal" class="forgot">Forgot Password</a>
        </form> -->
        <form [formGroup]="form" (ngSubmit)="submit(form.value)" class="pt-2">
            <div class="loginFormContainer">
                <div class="text-center" data-background-color="orange">
                    <h2 class="mb-5 formHeading">Log In</h2>
                    <app-error-label [control]="form" [submitted]="submitted"></app-error-label>
                </div>
                <div class="">
                    <div class="form-group">
                        <input class="form-control" formControlName="email" type="email" name="email" placeholder="Email">
                        <div class="alert error" *ngIf="!form.controls['email'].valid && form.controls['email'].touched">
                            Email is required
                        </div>
                    </div>

                    <div class="form-group">
                        <input class="form-control" formControlName="password" type="password" name="password" placeholder="Password">
                        <div class="alert error" *ngIf="!form.controls['password'].valid && form.controls['password'].touched">
                            Password is required
                        </div>
                    </div>
                </div>
              <button type="submit" class="button button_emi">LOG IN</button>

            </div>
            <a data-toggle="modal" data-target="#forgotpasswordModal" class="forgot">Forgot Password</a>
      </form>
      </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="forgotpasswordModal" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="text-center">Forgot Password</h4>
        <button type="button" class="close addCursor" data-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body">
        <form class="viewProfileForm" (ngSubmit)="onForgotPasswdSubmit(forgotPasswordForm.value); forgotPasswordForm.reset()" #forgotPasswordForm="ngForm">
          <div class="row justify-content-center">
            <div class="col-12">
              <div class="form-group">
                <input type="email" class="form-control" placeholder="Enter Email"  id="email" required name="email" #email="ngModel" ngModel>
                <button class="button mt-3 pull-right" type="submit"  [disabled]="!forgotPasswordForm.valid">Submit</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/authentication/login/login.component.html